import { widgetAppearanceType } from "../enums"
import { reportSources } from "../reports/reports-list/reports-list.component";

export interface agent {
    avgSpeaktime: number,
    avgSurveyScore: number,
    avgWrapup: number,
    callsAnswered: number,
    callsOffered: number,
    chatCapacityMaxParallel: number,
    chatConnecting: number,
    chatOngoing: number,
    chatPhoneThreshold: number,
    contactCentreStatus: number,
    firstName: string,
    lastName: string,
    name: string,
    phoneNumber: string,
    profileName: string,
    secondsInPause: number,
    secondsLoggedIn: number,
    simpleStatus: number,
    statusDescription: string,
    statusDetails: string,
    statusSource: number,
    surveyAnswered: number,
    timeInStatus: number,
    unblockableMasterId: number,
    userId: number,
    userStatus: number,
    userStatusId: number,
    usergroupName: string
}

export interface queue {
    Id :number,
    Description:string,
    OpenForWebAccessInt?:number
    OpenForWebAccess?:boolean,
    CallsDisconnectedToday?:number,
    CiqScheduled?:number,
    AlarmFlag?:number,
    CallsAnsweredWithinSla?:number,
    CiqsAnsweredToday?:number,
    CiqsOfferedToday?:number,
    CallsAnsweredToday?:number,
    CallsOfferedToday?:number,
    QueueSizePreferred?:number,
    CallsDisconnectedWithinSla?:number,
    UnblockedUnavailable?:number,
    QueueSizeCiq?:number,
    Sla?:number,
    AgentsUnavailable?:number,
    AgentsInPause?:number,
    AgentsReady?:number,
    AgentsLoggedIn?:number,
    QueueSize?:number,
    WaitTimeAverage?:number,
    WaitTimeMax?:number,
    UnblockedLoggedIn?:number,
    SilentCallsToday?:number,
}

export interface dashboardConfig{
    widgetRefreshInterval:widgetRefreshInterval,
    maxWidgetsPerDashboard:number,
    maxDashboards:number,
    isDefault:boolean
}

interface widgetRefreshInterval{
    realTime:number,
    traffic:number,
    wfm:number
}

export interface widgetAppearance {
    type: widgetAppearanceType,
    label: string,
    name?: string,
    fontSize?: number,
    color?: string,
    defFontSize: number,
    defColor: string,
    defName?: string
    editName: boolean
}

export const widgetTypes = [
    { value: 0, label: 'Bar', group: 'Chart', icon: 'fa-chart-bar', disabled:false },
    { value: 1, label: 'Line', group: 'Chart', icon: 'fa-chart-line', disabled:false },
    { value: 2, label: 'Area', group: 'Chart', icon: 'fa-chart-area', disabled: false },
    { value: 3, label: 'Label', group: 'Other', icon: 'fa-th-large', disabled: false },
    { value: 4, label: 'Table', group: 'Other', icon: 'fa-list-alt', disabled: false }
];

export interface report {
    id: number,
    subReportId: number,
    shortDescription: string,
    longDescription: string,
    userDescription: string,
    reportPath,
    standReportName: string,
    categoryId: number,
    category: string,
    dimensions: any[],
    columns: column[],
    allColumns: column[],
    rawColumns: string[],
    defaultColumns: string[],
    parameters: any[],
    isNonStandardReport: boolean,
    delayMinute: number,
    preset: any,
    disableCharts?: boolean,
    lastReportTime?: Date,
    isCustom?: boolean,
    report_Source: reportSources
}

export interface column {
    id: number,
    labelCode: string,
    shortDescription: string,
    longDescription: string,
    hideable: boolean,
    order: number,
    isKey:boolean
}

export interface saveReportModel {
    setup: any,
    id: number,
    subReportId: number,
    shortDescription: string,
    userDescription: string,
    categoryId: number | null
}

export interface updateCategoriesListModel {
    deleted: number[]
    changed: changeCategory[],
    added: newCategory[]
}

export interface newCategory {
    id: number,
    category: string
}

export interface changeCategory {
    id: number,
    category: string
}

export interface reportCategory {
    id: number,
    category: string,
    inUse: number
}

export interface reportStorageInfo {
    id: number,
    customerKey: string,
    countryCode: string,
    country: string,
    daysToStore: number,
    minuteDelay: number,
    autoupdatedata:string,
    daysToStoreAgent?: number,
}
